import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=91cd23c4&scoped=true&"
import script from "./ResourceDetail.vue?vue&type=script&lang=js&"
export * from "./ResourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=91cd23c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cd23c4",
  null
  
)

export default component.exports